export const wyjazdToLower = function(str) {

	if (str != null && (typeof str === "string")) {
		str = str.replace(/ą/g, 'a');
		str = str.replace(/ę/g, 'e');
		str = str.replace(/ó/g, 'o');
		str = str.replace(/ł/g, 'l');
		str = str.replace(/ś/g, 's');
		str = str.replace(/ć/g, 'c');
		str = str.replace(/ń/g, 'n');
		str = str.replace(/ż/g, 'z');
		str = str.replace(/ź/g, 'z');

		str = str.replace(/Ą/g, 'A');
		str = str.replace(/Ę/g, 'E');
		str = str.replace(/Ó/g, 'O');
		str = str.replace(/Ł/g, 'L');
		str = str.replace(/Ś/g, 'S');
		str = str.replace(/Ć/g, 'C');
		str = str.replace(/Ń/g, 'N');
		str = str.replace(/Ż/g, 'Z');
		str = str.replace(/Ź/g, 'Z');

		str = str.replace(/ /g, '.');
		str = str.toLowerCase();
	}
	return str;
};
